import { ErrorToast } from '../utils/Utils';

export const normalizeHexColor = (input) => {
  if (input == null) return '';
  if (typeof input !== 'string') return '';
  let s = input.trim().replace(/^#/, '');
  if (s.length === 3 && /^[0-9a-fA-F]{3}$/.test(s)) {
    s = s
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (!/^[0-9a-fA-F]{6}$/.test(s)) return '';
  return `#${s.toLowerCase()}`;
};

export const isValidHexColor = (input) => normalizeHexColor(input) !== '';

/** Coerces gradient choice to "1", "2", or "3" for API payloads. */
export const normalizeGradientVariant = (v) => {
  if (v == null || v === '') return '1';
  const s = String(v).trim();
  if (s === '1' || s === '2' || s === '3') return s;
  const n = parseInt(s, 10);
  if (n === 1 || n === 2 || n === 3) return String(n);
  return '1';
};

/**
 * GET rockedNetworkPartners/:id may return a Sequelize instance; most fields are under dataValues.
 * Some attributes (e.g. backgroundColor, gradientVariant) may only exist on the outer instance.
 */
export const unwrapRnpPartnerDetail = (res) => {
  if (res == null || typeof res !== 'object') return null;
  if (res.dataValues && typeof res.dataValues === 'object') {
    const inner = { ...res.dataValues };
    if (res.backgroundColor != null) inner.backgroundColor = res.backgroundColor;
    const gv =
      res.gradientVariant ??
      res.gradientVarient ??
      inner.gradientVariant ??
      inner.gradientVarient;
    if (gv != null) inner.gradientVariant = gv;
    return inner;
  }
  return res;
};

export const checkType = (variable) => {
  if (typeof variable === 'string') {
    return false;
  }
  return true;
};

export const convertToFormData = (data) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('displayName', data.displayName);
  formData.append('type', data.type);
  if (data.logo && checkType(data.logo)) {
    formData.append('logo', data.logo);
  }
  if (data.icon && checkType(data.icon)) {
    formData.append('icon', data.icon);
  }
  if (data.backgroundColor && isValidHexColor(data.backgroundColor)) {
    formData.append('backgroundColor', normalizeHexColor(data.backgroundColor));
  }
  formData.append('gradientVariant', normalizeGradientVariant(data.gradientVariant ?? data.gradientVarient));
  return formData;
};

export const validateForm = (data, add) => {
  if (!data?.name) {
    ErrorToast('Enter a name');
    return false;
  }
  if (!/\S/.test(data?.name)) {
    ErrorToast('Enter a valid name');
    return false;
  }
  if (!data?.displayName) {
    ErrorToast('Enter a display name');
    return false;
  }
  if (!/\S/.test(data?.displayName)) {
    ErrorToast('Enter a valid display name');
    return false;
  }
  if (add && !data?.logo) {
    ErrorToast('Select a logo');
    return false;
  }
  if (add && !data?.icon) {
    ErrorToast('Select an icon');
    return false;
  }
  if (!isValidHexColor(data?.backgroundColor)) {
    ErrorToast('Select RNP Background Color');
    return false;
  }
  return true;
};
